import {handlePrecision} from "components/dashboard/product-template-table/utils/utils";
import React, {useRef} from 'react';
import {Dropdown, DropdownChangeParams} from 'primereact/dropdown';
import {IDoubleProps} from "../../../utils/cellInterfaces";

export default function Double(props: IDoubleProps) {
    const convertToNumber = (value: string) => {
        return parseFloat(value);
    }

    const onSelect = (e: DropdownChangeParams) => {
        props.changeHandler(convertToNumber(e.value));
    }

    const handleChangeValue = (value: any) => {
        if (value !== null && value !== undefined) {
            const changedVal = value.replaceAll(',', '.');
            if (!isNaN(changedVal)) {
                props.changeHandler(changedVal);
            }
        } else {
            props.changeHandler('');
        }
    }

    const onBlurSetPrecision = () => {
        try {
            let float = parseFloat(props.value.toString());
            if (isNaN(float)) {
                float = 0.00;
            }
            const newValue = handlePrecision(float, props.precision);
            props.changeHandler(newValue);
        } catch (err) {
            console.log(`Float parsing error, cannot parse:${  props.value}`);
        }
    }

    const onFocus = (e: any) => {
        e.target.select()
    }

    const myRef = useRef(null);

    const onClick = () => {
        if (myRef) {
            // @ts-ignore
            myRef.current.focus();
        }
    }


    if (props.isInEditMode) {
        if (props.selectionValues && props.selectionValues.length > 0) {
            return <Dropdown
                value={props.value}
                style={{width: '100%', textAlign: 'left'}}
                options={props.selectionValues}
                placeholder={String(props.value)}
                onChange={(e) => onSelect(e)}
                required
            />
        } 
            // @ts-ignore
            return <div className="p-inputtext p-d-flex p-jc-between" style={{padding: '0'}} onClick={() => onClick()}>
                    <input ref={myRef}
                           className="p-inputtext"
                           style={{border: 'none', float: 'left', width: '100%'}}
                           value={handlePrecision(props.value, props.precision)}
                           onChange={(e) => handleChangeValue(e.target.value)}
                           onBlur={() => onBlurSetPrecision()}
                           onFocus={onFocus}
                    />
                    {
                        props.unit && props.unit.replaceAll(' ', '') && <label style={{padding: '12px'}}>
                            {` ${  props.unit}`}
                        </label>
                    }
                </div>
        
    } 
        return <div className="p-inputtext"
                    style={{whiteSpace: "nowrap", backgroundColor: "inherit", color: "inherit", border: "none"}}>
            {`${handlePrecision(props.value, props.precision, true)  } ${  props.unit}`}
        </div>
    

}